import { createApp } from '@app/adapters/create-app'
import ShareTrigger from '@app/application/pulse-share/share-trigger.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='share-trigger']"
  ) as HTMLElement

  if (element) {
    createApp(ShareTrigger, element.dataset).mount(element)
  }
})
